export default ({ valid }, { localize }) =>
  !valid ? localize('Вкажіть, будь-ласка, правильний номер телефону') : null;
